export default "__VITE_ASSET__CCRTn9rk__"